import React from 'react';
import { FaTimes, FaSearchPlus, FaSearchMinus, FaExpand, FaCompress } from 'react-icons/fa';
import { BiRotateLeft, BiRotateRight } from 'react-icons/bi';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import './PDFViewer.css';

const PDFViewer = ({ pdfUrl, onClose }) => {
  const [isFullscreen, setIsFullscreen] = React.useState(false);
  const [rotation, setRotation] = React.useState(0);
  const [zoom, setZoom] = React.useState(100);
  const iframeRef = React.useRef(null);

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const handleZoom = (direction) => {
    setZoom(prev => {
      const newZoom = direction === 'in' ? prev + 10 : prev - 10;
      return Math.min(Math.max(50, newZoom), 200);
    });
  };

  const handleRotate = (direction) => {
    setRotation(prev => {
      const newRotation = direction === 'right' ? prev + 90 : prev - 90;
      return newRotation % 360;
    });
  };

  return (
    <div className="pdf-viewer-overlay">
      <div className="pdf-viewer-container">
        <div className="pdf-viewer-header">
          <div className="pdf-controls">
            <div className="control-group">
              <button
                className="control-button"
                onClick={() => handleZoom('out')}
                title="Zoom Out"
              >
                <FaSearchMinus />
              </button>
              <span className="zoom-level">{zoom}%</span>
              <button
                className="control-button"
                onClick={() => handleZoom('in')}
                title="Zoom In"
              >
                <FaSearchPlus />
              </button>
            </div>

            <div className="control-group">
              <button
                className="control-button"
                onClick={() => handleRotate('left')}
                title="Rotate Left"
              >
                <BiRotateLeft />
              </button>
              <button
                className="control-button"
                onClick={() => handleRotate('right')}
                title="Rotate Right"
              >
                <BiRotateRight />
              </button>
            </div>

            <div className="control-group">
              <button
                className="control-button"
                onClick={handleFullscreen}
                title="Toggle Fullscreen"
              >
                {isFullscreen ? <FaCompress /> : <FaExpand />}
              </button>
            </div>
          </div>

          <button
            onClick={onClose}
            className="close-button"
            title="Close"
          >
            <FaTimes />
          </button>
        </div>

        <div className="pdf-content" style={{ transform: `rotate(${rotation}deg)` }}>
          {/* <iframe
            ref={iframeRef}
            src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1&zoom=${zoom}`}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ transform: `scale(${zoom / 100})`, transformOrigin: 'center center' }}
            frameBorder="0"
          /> */}

          <object
            data={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1&zoom=${zoom}`}
            type="application/pdf"
            width="100%"
            height="100%"
            aria-label="PDF Viewer"
          >
            <p>Your browser does not support PDFs.</p>
          </object>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;